import React from 'react';
import SEO from '../SEO/SEO';
import './About.css';

/**
 * Página Sobre
 * Informações sobre a calculadora e seus desenvolvedores
 */
const About = () => {
  return (
    <div className="about-page">
      <SEO 
        title="Sobre a Calculadora de Juros Compostos" 
        description="Conheça mais sobre a calculadora de juros compostos, sua história e o time responsável pelo desenvolvimento."
        keywords={['sobre', 'calculadora juros compostos', 'desenvolvedores', 'história']}
      />

      <div className="container page-container">
        <div className="page-header">
          <h1>Sobre a Calculadora</h1>
        </div>

        <div className="content-section">
          <h2>Nossa Missão</h2>
          <p>
            A Calculadora de Juros Compostos foi criada com o objetivo de democratizar o acesso à educação financeira e 
            fornecer ferramentas gratuitas para que qualquer pessoa possa planejar seu futuro financeiro.
          </p>
          <p>
            Acreditamos que a independência financeira não deve ser privilégio de poucos, e que com as ferramentas certas 
            e conhecimento adequado, todos podem tomar melhores decisões sobre seus investimentos.
          </p>
        </div>

        <div className="content-section">
          <h2>Recursos</h2>
          <p>Nossa calculadora oferece:</p>
          <ul>
            <li>Cálculos precisos de juros compostos com aportes mensais</li>
            <li>Comparação visual de diferentes cenários de investimento</li>
            <li>Planejamento de marcos financeiros e objetivos</li>
            <li>Simulador completo de aposentadoria e independência financeira</li>
            <li>Visualizações gráficas intuitivas</li>
            <li>Interface adaptada para dispositivos móveis e desktop</li>
            <li>Modo escuro para uso noturno</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>Tecnologias</h2>
          <p>
            Desenvolvemos esta aplicação utilizando tecnologias modernas e de código aberto, incluindo React, 
            Recharts para visualizações de dados, Context API para gerenciamento de estado, e CSS responsivo.
          </p>
          <p>
            Todo o código da calculadora é otimizado para oferecer a melhor experiência ao usuário, com carrregamento 
            rápido e cálculos precisos.
          </p>
        </div>

        <div className="content-section">
          <h2>Equipe</h2>
          <p>
            Esta calculadora foi desenvolvida por profissionais apaixonados por tecnologia e educação financeira, 
            com o objetivo de criar uma ferramenta útil e acessível.
          </p>
          <p>
            Agradecemos a todos os usuários que contribuem com feedback e sugestões para 
            continuarmos melhorando nossa aplicação.
          </p>
        </div>

        <div className="content-section">
          <h2>Contato</h2>
          <p>
            Tem dúvidas, sugestões ou encontrou algum problema? Ficaremos felizes em ouvir você!
          </p>
          <p>
            Entre em contato conosco pelo email: <a href="mailto:contato@calculadorajuroscompostos.com.br">contato@calculadorajuroscompostos.com.br</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
